import { Injector, inject } from '@angular/core';

import { ClientConfigProductName, ProductService } from '@frontend/vanilla/core';

import { PokerAppLazyBootstrapService } from './host-app/bootstrap/poker-app-lazy-bootstrap.service';

export const pokerProductDeactivateGuard = () => {
    inject(ProductService).deactivateProduct(ClientConfigProductName.POKER);
};

export const pokerProductActivateGuard = () => {
    const productService = inject(ProductService);

    const metadata = productService.getMetadata(ClientConfigProductName.POKER);

    if (!metadata.isRegistered) {
        productService.register(ClientConfigProductName.POKER, inject(Injector));
    }

    inject(ProductService).setActive(ClientConfigProductName.POKER);
    return inject(PokerAppLazyBootstrapService).onPokerAppInit();
};
